import './TitleSection.css'

const TitleSection = ({titleSection})=>{
    return(
        <>
        <h3 className='tilteSection'>{titleSection}</h3>
        </>
    )
}

export default TitleSection